const defaultState = {};
export default (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_ALARM_RELAY_STATUS_SUCCESS':
      return action.alarmStatus;
    default:
      return state;
  }
};
